import React, { useMemo, useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import { GET_EXPORT_SHIPMENT_DUE_DATE_REPORT } from "../../services/apiRoutes";
import { AuthContext } from "../../context/AuthContext";
import { getColorById, getColorPlate, getCustumersList } from "../../services/CommonServices";
import CustomLoader from "../common/CustomLoader";
import CustomReport from "../common/CustomReport";
import { genericPost } from "../../services/authServices";
import CustomTextField from "../common/CustomTextField";
import CustomFilter from "../common/CustomFilter";
import CustomButton from "../common/CustomButton";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { ClearRounded } from "@mui/icons-material";
import CustomAutocomplete from "../common/CustomAutoComplete";
import { useCompanyDateFormat } from "../../constants/useCompanyDateFormat";
import CustomDataTable from "../common/CustomDataTable";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import { useLocation } from "react-router-dom";
import CustomStatus from "../common/CustomStatus";



const title = "Due Date Export Shipment Report";

const DueDateExportShipmentReport = () => {
    const companyDateFormat = useCompanyDateFormat();
    const [permission, setPermissions] = useState()
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const { token } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const filterOpen = () => setOpenDrawer(true);
    const filterClose = () => setOpenDrawer(false);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [custumersList, setCustumersList] = useState([]);
    const [page, setPage] = useState(0); // UI 0-based
    const [pageSize, setPageSize] = useState(10);
    const [rowCount, setRowCount] = useState(0);
    const [colorlist, setColorlist] = useState([]);
    const [filterPayload, setFilterPayload] = useState({
        shipmentId: '',
        customerNamesId: '',
        fromDate: '',
        toDate: '',

    });
    const location = useLocation();
    const currentPath = location.pathname;
    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])

    const handleFilterChange = (field, value) => {
        setFilterPayload((prev) => ({
            ...prev,
            [field]: value || '',
        }));
    };
    const handleClearFilters = useMemo(() => {
        return () => {
            setFilterPayload({
                shipmentId: '',
                customerNamesId: '',
                fromDate: '',
                toDate: '',
            });
            fetchData(0, pageSize, '');
        };
    }, [pageSize]);
    useEffect(() => {
        getCommonData();
    }, []);
    const getCommonData = async () => {
        const custumersList = await getCustumersList();
        setCustumersList(custumersList);
        const colorData = await getColorPlate();
        setColorlist(colorData);

    }



    const columns = useMemo(
        () => [
            { accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" }, enableColumnFilter: false },
            { accessorKey: 'shipmentId', header: 'Shipment ID', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'date', header: 'CI Date', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'commercialInvoiceNo', header: 'CI No.', size: 50, tableStyle: { textAlign: "center" }, },

            {
                accessorKey: 'clientCompanyName', header: 'Customer Name', size: 50, tableHeader: {
                    justifyContent: 'flex-start',
                },
            },

            {
                accessorKey: "billingCountry",
                header: "Country",
                tableStyle: { textAlign: "center" },
                size: 50,
                Cell: ({ row }) => {
                    return (
                        <CustomStatus
                            title={row.original.billingCountry}
                            sx={{
                                backgroundColor: row.original.countryIdBackground,
                                color: row.original.countryIdColor,
                                border: `1px solid ${row.original.countryIdColor}`,
                                textAlign: "center",
                                display: "inline-block",
                            }}
                        />
                    );
                },
                enableSorting: false,
            },
            { accessorKey: 'amount', header: 'Amount', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'advance', header: 'advance', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'final', header: 'final', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'totalAdvancePaymentAmount', header: 'Payment', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'totalBalance', header: 'Balance', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'creditDay', header: 'Credit Day', size: 50, tableStyle: { textAlign: "center" }, },
            { accessorKey: 'dueDate', header: 'due Date', size: 50, tableStyle: { textAlign: "center" }, },
            // { accessorKey: 'remainingDay', header: 'Day Status', size: 50, tableStyle: { textAlign: "center" }, },
            {
                accessorKey: 'remainingDay', header: 'Day Status',
                tableStyle: { textAlign: "center" },
                size: 50,
                Cell: ({ row }) => {
                    return (
                        <CustomStatus
                            title={row.original.remainingDay}
                            sx={{
                                backgroundColor: row.original.statusBackground,
                                color: row.original.statusColor,
                                border: `1px solid ${row.original.statusColor}`,
                                textAlign: "center",
                                display: "inline-block",
                            }}
                        />
                    );
                },
                enableSorting: false,
            },
        ],
        [permission]
    );

    const fetchData = async (pageIndex = 0, pageSize = 10) => {
        setLoading(true);
        try {
            const payload = {
                page: pageIndex + 1,
                limit: pageSize,
                ...filterPayload
            };

            const response = await genericPost(GET_EXPORT_SHIPMENT_DUE_DATE_REPORT, payload, {});

            if (response.data.success && response.data.data?.length) {

                const shipmentData = response.data.data.map((item, index) => {

                    // 🔸 Sum Advance Receipt referenceAmount
                    const advanceReceiptTotal = item.receiptParticularsAdvance?.reduce(
                        (sum, r) => sum + Number(r.referenceAmount || 0),
                        0
                    );

                    // 🔸 Sum Final Receipt referenceAmount
                    const finalReceiptTotal = item.receiptParticularsFinal?.reduce(
                        (sum, r) => sum + Number(r.referenceAmount || 0),
                        0
                    );

                    // 🔸 Total advance + final payments (if needed)
                    const totalAdvancePaymentAmount = Number(item.totalAdvancePaymentAmount || 0);

                    // 🔸 Payment Balance
                    const balanceAmount = Number(item.totalBalanceAmount || 0);

                    // 🔸 Due Date Logic: if onBoardDate exists use that else CI dueDate
                    const rawDueDate = item.onBoardDate ? item.onBoardDate : item.dueDate;

                    // 🔸 Remaining / Overdue / Payment Done Logic
                    const remainingDay = (() => {
                        if (balanceAmount <= 0) {
                            return "Payment Done";
                        }

                        if (!rawDueDate) return "";

                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const due = new Date(rawDueDate);
                        due.setHours(0, 0, 0, 0);

                        const diffDays = Math.ceil((due - today) / (1000 * 60 * 60 * 24));

                        if (diffDays < 0) {
                            return `${Math.abs(diffDays)} Over Days`;
                        } else {
                            return `${diffDays} Remaining Days`;
                        }
                    })();

                    const countryColorObj = getColorById(item.customer?.billingCountry.id, colorlist, {
                        matchKey: "colorId",
                        prefixLength: 1,
                    });
                    // @@@@@@@@@@@@@@@@@
                    const balance = Number(item.totalBalanceAmount || 0);
                    let remainingDayText = "";
                    let statusColor = "";
                    let statusBackground = "";
                    if (balance <= 0) {
                        // ✅ Payment Done
                        remainingDayText = "Payment Done";
                        statusColor = "#1B5E20";          // dark green
                        statusBackground = "#C8E6C9";    // light green
                    } else if (rawDueDate) {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const due = new Date(rawDueDate);
                        due.setHours(0, 0, 0, 0);
                        const diffDays = Math.ceil((due - today) / (1000 * 60 * 60 * 24));
                        if (diffDays < 0) {
                            // ❌ Overdue
                            const overdueDays = Math.abs(diffDays);
                            remainingDayText = `${overdueDays} Over Days`;
                            statusColor = "#B71C1C";        // dark red
                            statusBackground = "#FFCDD2";  // light red
                        } else {
                            // ⏳ Remaining
                            remainingDayText = `${diffDays} Remaining Days`;
                            // Optional: different colors based on urgency
                            if (diffDays <= 3) {
                                statusColor = "#E65100";        // dark orange
                                statusBackground = "#FFE0B2";  // light orange
                            } else {
                                statusColor = "#0D47A1";        // dark blue
                                statusBackground = "#BBDEFB";  // light blue
                            }
                        }
                    }
                    return {
                        index: (index + 1).toString().padStart(2, "0"),

                        commercialInvoiceId: item.commercialInvExpId,
                        commercialInvoiceNo: item.commercialInvoiceNo,
                        shipmentId: item.shipmentId,

                        date: companyDateFormat(item.date),
                        dueDate: companyDateFormat(rawDueDate),

                        clientCompanyName: item.customer?.clientCompanyName || "",
                        billingCountry: item.customer?.billingCountry?.name || "",

                        amount: `${item.currency?.currency_symbol || ""} ${Number(item.totalCIAmount || 0).toFixed(2)}`,
                        advance: `${item.currency?.currency_symbol || ""} ${Number(advanceReceiptTotal || 0).toFixed(2)}`,
                        final: `${item.currency?.currency_symbol || ""} ${Number(finalReceiptTotal || 0).toFixed(2)}`,

                        totalAdvancePaymentAmount: `${item.currency?.currency_symbol || ""} ${Number(totalAdvancePaymentAmount).toFixed(2)}`,
                        totalBalance: `${item.currency?.currency_symbol || ""} ${balanceAmount.toFixed(2)}`,

                        creditDay: `${item.ProformaInvExp?.creditDay || 0} Day`,
                        remainingDay,

                        countryIdColor: countryColorObj.color || '',
                        countryIdBackground: countryColorObj.backgroundColor || '',
                        statusColor: statusColor || '',
                        statusBackground: statusBackground || '',

                    };
                });

                setData(shipmentData);
                setRowCount(response.data.pagination?.totalRecords || 0);

            } else {
                setData([]);
                setError("No records found");
            }

        } catch (error) {
            console.error("Error fetching shipments", error);
            setError("Error fetching shipments");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchData(page, pageSize)
    }, [token, page, pageSize, colorlist])

    const defaultView = 'duedateexportshipmentreport';
    const mainContent = (
        <>
            <CustomLoader open={loading} />
            <CustomDataTable
                title={title}
                columns={columns}
                data={data}
                handleFilterButton={filterOpen}
                fiterButtonTitile="Fiter"
                rowCount={rowCount}
                page={page}
                setPage={setPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                fromDate={filterPayload.fromDate || ""}
                toDate={filterPayload.toDate || ""}
            />
            <CustomFilter
                drawerTitle="Filter Options"
                drawerWidth={300}
                openDrawer={openDrawer}
                onClose={filterClose}
                drawerContent={
                    <>
                        <Box>
                            <Grid container spacing={1} sx={{ padding: 0, }}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        type="text"
                                        placeholder="Enter Shipment ID"
                                        value={filterPayload.shipmentId}
                                        onChange={(e) => handleFilterChange('shipmentId', e.target.value)}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomAutocomplete
                                        options={custumersList}
                                        getOptionLabel={(option) => option.title}
                                        placeholder="Select Customer"
                                        value={custumersList.find((item) => item.id === filterPayload.customerNamesId) || null}
                                        onChange={(event, newValue) => handleFilterChange("customerNamesId", newValue?.id)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="from Date"
                                        type="date"
                                        value={filterPayload.fromDate}
                                        onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                        placeholder="From Date"
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12} md={12}>
                                    <CustomTextField
                                        fieldLabel="to Date"
                                        type="date"
                                        value={filterPayload.toDate}
                                        onChange={(e) => handleFilterChange('toDate', e.target.value)}
                                        placeholder="To Date"
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                                    <CustomButton
                                        startIcon={<FindReplaceOutlinedIcon />}
                                        title="Apply"
                                        size="small"
                                        variant="contained"
                                        onClick={fetchData}
                                    />
                                    <CustomButton
                                        variant="outlined"
                                        title="Clear"
                                        startIcon={<ClearRounded />}
                                        onClick={handleClearFilters}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </>
                }
            />
        </>
    );

    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };
    return (
        <>
            <>
                <CustomReport
                    defaultView={defaultView}
                    mainContent={getMainContent(mainContent, permission)} />
                {!permission?.view && <AccessDenied />}
            </>
        </>
    );
};
export default DueDateExportShipmentReport;
